import { SvgIcon } from '@mui/material';
import './ccf-routing-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfRoutingIconProps  {}

/**
 *
 * @param props - CcfRoutingIcon
 * @example <CcfRoutingIcon />
 * @returns
 */
export function CcfRoutingIcon(props: CcfRoutingIconProps) {
  return (
    <SvgIcon
      // width="18"
      // height="20"
      // viewBox="0 0 18 20"
      // fill="none"
      {...props}
    >
      <path
        d="M16 14.2V5.8C17.2 5.4 18 4.3 18 3C18 1.3 16.7 0 15 0C13.3 0 12 1.3 12 3C12 4.3 12.8 5.4 14 5.8V9H5C3.3 9 2 10.3 2 12V14.2C0.8 14.6 0 15.7 0 17C0 18.7 1.3 20 3 20C4.7 20 6 18.7 6 17C6 15.7 5.2 14.6 4 14.2V12C4 11.4 4.4 11 5 11H14V14.2C12.8 14.6 12 15.7 12 17C12 18.7 13.3 20 15 20C16.7 20 18 18.7 18 17C18 15.7 17.2 14.6 16 14.2ZM3 18C2.4 18 2 17.6 2 17C2 16.4 2.4 16 3 16C3.6 16 4 16.4 4 17C4 17.6 3.6 18 3 18ZM15 2C15.6 2 16 2.4 16 3C16 3.6 15.6 4 15 4C14.4 4 14 3.6 14 3C14 2.4 14.4 2 15 2ZM15 18C14.4 18 14 17.6 14 17C14 16.4 14.4 16 15 16C15.6 16 16 16.4 16 17C16 17.6 15.6 18 15 18Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfRoutingIcon;
